import { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';

/**
 * Global handler that catches OAuth tokens on ANY page
 * This is needed because Supabase might redirect to the homepage with tokens
 * instead of the /auth/callback page.
 * 
 * When we detect tokens on a mobile browser (Chrome), we redirect to the native app.
 */
export function MobileOAuthHandler() {
  const [showRedirectUI, setShowRedirectUI] = useState(false);
  const [tokens, setTokens] = useState<{ hash: string } | null>(null);

  useEffect(() => {
    // Don't run inside Capacitor native app - only in browser
    if (Capacitor.isNativePlatform()) {
      return;
    }
    
    const hash = window.location.hash;
    if (!hash || !hash.includes('access_token')) {
      return; // No OAuth tokens in URL
    }

    console.log('[MobileOAuthHandler] Detected OAuth tokens in URL');
    console.log('[MobileOAuthHandler] Hash:', hash.substring(0, 50) + '...');

    // Check if we have tokens
    const hashParams = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
    const accessToken = hashParams.get('access_token');
    const refreshToken = hashParams.get('refresh_token');

    if (!accessToken || !refreshToken) {
      console.log('[MobileOAuthHandler] Missing tokens, skipping');
      return;
    }

    // Check if this is an Android mobile browser
    const isAndroid = /android/i.test(navigator.userAgent);
    const isMobile = /mobile|android|iphone|ipad/i.test(navigator.userAgent);

    console.log('[MobileOAuthHandler] isAndroid:', isAndroid);
    console.log('[MobileOAuthHandler] isMobile:', isMobile);

    // DISABLED: Mobile app redirect logic removed per user request
    // OAuth should always stay in browser, never redirect to mobile app
    // if (isAndroid) {
    //   console.log('[MobileOAuthHandler] Android detected, redirecting to native app...');
    //   
    //   setTokens({ hash });
    //   
    //   // Build the redirect URL with tokens
    //   // Use Android Intent URL for reliable app opening
    //   const intentUrl = `intent://auth/callback${hash}#Intent;scheme=metefy;package=com.metefy.app;end`;

    //   console.log('[MobileOAuthHandler] Intent URL:', intentUrl.substring(0, 100) + '...');

    //   // Redirect to the app
    //   window.location.href = intentUrl;

    //   // Show UI after a delay if still in browser
    //   setTimeout(() => {
    //     if (document.hasFocus()) {
    //       console.log('[MobileOAuthHandler] Still in browser, showing manual redirect UI');
    //       setShowRedirectUI(true);
    //     }
    //   }, 1500);
    // }
  }, []);

  // DISABLED: Mobile app redirect function removed per user request
  // const handleOpenApp = () => {
  //   if (!tokens) return;
  //   
  //   const intentUrl = `intent://auth/callback${tokens.hash}#Intent;scheme=metefy;package=com.metefy.app;end`;
  //   window.location.href = intentUrl;
  // };

  // DISABLED: Mobile app redirect UI removed per user request
  // OAuth should always stay in browser
  // if (showRedirectUI && tokens) {
  //   return (
  //     <div className="fixed inset-0 z-[9999] bg-white flex items-center justify-center p-4">
  //       <div className="text-center max-w-md">
  //         <div className="w-16 h-16 mx-auto mb-4 bg-sky-100 rounded-full flex items-center justify-center">
  //           <svg className="w-8 h-8 text-sky-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
  //             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
  //           </svg>
  //         </div>
  //         <h2 className="text-xl font-bold text-gray-900 mb-2">Login Successful!</h2>
  //         <p className="text-gray-600 mb-6">
  //           Tap the button below to return to the Metefy app.
  //         </p>
  //         <button
  //           onClick={handleOpenApp}
  //           className="w-full bg-sky-700 hover:bg-sky-800 text-white font-semibold py-3 px-6 rounded-lg transition-colors mb-3"
  //         >
  //           Open Metefy App
  //         </button>
  //         <p className="text-sm text-gray-500">
  //           If the app doesn't open, please open Metefy manually.
  //         </p>
  //       </div>
  //     </div>
  //   );
  // }

  return null;
}

